







































































import Vue from 'vue';
import Component from 'vue-class-component';
import { JsonObj } from 'vue-meta/types/vue-meta';
import SliderAlimentation from '@/components/santeEnfant/template/SliderAlimentation.vue';

const Props = Vue.extend({
	props: {
		mois: {
			type: Number,
			default: 1
		}
	},
	data: function() {
		return {
			index: this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length<3?this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length:3,
			nbrealiment: this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length,
			componentKey: 0
		};
	},
	watch: {
		mois: function(val) {
			// FORCE RECHARGEMENT DU SLIDER
			this.componentKey +=1;
		}
	},
	methods: {
		// Test si la tranche d'age contient un texte après le slider
		isTextSuite: function() {
			var trancheAge = this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()) as unknown as JsonObj;
			if (trancheAge.textsuite) {
				return true;
			}
			return false;
		}
	}
});

@Component({
	components: {
		SliderAlimentation
	}
})
export default class AlimentationSanteEnfant extends Props {
}
